<template>
      <v-sheet class="transparent py-7">
        <v-card elevation="0">
          <v-card-text>
            <div class="mb-8">
              <h1 class="font-weight-black primary-color  display-1">Cash Receipt</h1>
              <small class="font-weight-bold">Voucher Pengajuan Kas</small>
            </div>
              <v-text-field v-model="data.date" type="date" label="Tanggal" class="transparent mr-3"  color="teal"></v-text-field>
              <!-- <v-text-field v-model="data.time" type="time" label="Time" class="transparent"  color="teal"></v-text-field> -->
            <!-- <v-text-field label="Objective" v-model="data.objective" class="transparent"  color="teal"></v-text-field> -->
            <v-text-field label="Jumlah" type="number" v-model="data.amount" class="transparent"  color="teal"></v-text-field>
            <v-select v-model="data.receipt_id" item-text="role.name" item-value="id" :items="users" return-object color="teal" label="Ditujukan Kepada"></v-select>
            <v-select v-model="data.payment_type" :items="data.payments" return-object color="teal" label="Tipe pembayaran"></v-select>
            <v-textarea label="Rincian" v-model="data.details" color="teal"></v-textarea>
            
            <div class="d-flex w-100 align-items-center justify-end">
              <!-- <v-btn text>Selanjutnya </v-btn> -->
              <v-btn @click="sendData" class="primary-background text-end py-6" block elevation="6" dark>Kirim</v-btn>
            </div>
          </v-card-text>
        </v-card>
      </v-sheet>
</template>

<script>
import axios from 'axios'
import { mapActions , mapGetters} from 'vuex'
import numeral from 'numeral'
export default {
  data () {
    return {
      data : {
        receipt_id : '',
        date : '',
        time : '',
        user_id : '',
        details : '',
        amount : '',
        objective : '',
        payment_type : '',
        payments : [
          'cash',
          'debit',
          'credit',
        ],
        attachment : ''
      }
    }
  },
  mounted () {
    this.getUser()
      console.log(this.user)
      this.data.user_id = this.user.id
  },
  computed : {
    ...mapGetters({
      users : 'User/users',
      user : 'Auth/user',
    })
  },  
  methods : {
    ...mapActions({
      getUser : 'User/getUser',
      sendReceipt : 'Forms/sendReceipt'
    }),
    sendData () {
      this.sendReceipt(this.data)
    }
  }
}
</script>

<style>

</style>